module.exports = __webpack_public_path__ + "assets/img/wounded-heart.6a8be961.png";